import { AppSessionCellId } from "@hex/common";
import { useCallback } from "react";

import { useStableRef } from "../../hooks/useStableRef.js";
import { useStore } from "../../redux/hooks.js";
import {
  ExploreSpecSessionStateMP,
  appSessionMPSelectors,
} from "../../redux/slices/appSessionMPSlice.js";
import { useSessionContext } from "../../util/sessionContext.js";

export function useExploreSpecSessionStateGetter<T = ExploreSpecSessionStateMP>(
  selector?: (exploreSpecSessionState: ExploreSpecSessionStateMP) => T,
): (appSessionCellId: AppSessionCellId | undefined) => T | undefined {
  const { appSessionId } = useSessionContext();
  const store = useStore();
  const selectorRef = useStableRef(selector);

  return useCallback(
    (appSessionCellId: AppSessionCellId | undefined) => {
      if (!appSessionCellId) return undefined;

      const exploreSpecSessionState = appSessionMPSelectors
        .getExploreSpecSessionStateSelectors(appSessionId)
        .selectByAppSessionCellId(store.getState(), appSessionCellId);

      if (!exploreSpecSessionState) {
        return undefined;
      }

      const currentSelector = selectorRef.current;
      return currentSelector
        ? currentSelector(exploreSpecSessionState)
        : (exploreSpecSessionState as T);
    },
    [appSessionId, store, selectorRef],
  );
}
